import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import SidePanel from "../../components/SidePanel";
import Screen from "~/layouts/Screen/";
import Row from "~/layouts/Row";
import CustomersActionBar from "../../components/Bars/CustomersActionBar/index.web";
import Col from "../../layouts/Col";
import CustomersHeader from "../../components/Headers/CustomersHeader/index.web";
import palette from "~/styles/palette";
import CustomersList from "../../components/CustomersList/index.web";
import ParticipantDetails from "~/components/Participant/ParticipantDetails/index.web";
import ConversationContext from "~/contexts/ConversationContext";

export default function CustomersScreen() {
  const [activeCustomer, setActiveCustomer] = useState(null);
  const { conversation } = useContext(ConversationContext);
  const { customer } = conversation || {};

  return (
    <Screen>
      <Row style={[styles.inner]}>
        <SidePanel />
        <Col>
          <CustomersHeader />
          <Col pl={16} pr={16}>
            <CustomersActionBar />
            <CustomersList onPress={setActiveCustomer} />
          </Col>
        </Col>

        <Col style={[styles.rightPanel]}>
          {activeCustomer && <ParticipantDetails /> }
        </Col>
      </Row>
    </Screen>
  );
}

const styles = StyleSheet.create({
  centerPanel: {
    minWidth: 380,
    height: "100%",
  },
  rightPanel: {
    maxWidth: 500,
    borderLeftWidth: 1,
    borderLeftColor: "#eeeddd",
  },
  inner: {
    flex: 1,
    backgroundColor: palette.lightest_grey,
  },
  rightPanel: {
    maxWidth: "25%",
    minWidth: 375,
    borderLeftWidth: 1,
    borderLeftColor: "#eeeddd",
  },
});
